// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"311":"2d5857268bda6d7d","335":"3279e84d4f9dafb0"}[chunkId] + ".js";
};